import { setClinicLogoUrl, useConfig, useConfigDispatch } from '@context/ConfigurationContext'
import { useQuery } from 'react-query'
import { getClinic } from 'src/services/api/clinic'

export const useSetClinicLogoUrl = () => {
  const configDispatch = useConfigDispatch()
  const { clinicId } = useConfig()

  useQuery(['clinicTenantType', clinicId], () => getClinic(clinicId), {
    retry: 3,
    enabled: !!clinicId,
    onSuccess(data: { clinicLogoUrl: string | undefined }) {
      const { clinicLogoUrl } = data

      configDispatch(setClinicLogoUrl(clinicLogoUrl))
    },
  })
}
